module.exports = __webpack_public_path__ + "assets/img/typeIcon-4.96c0a749.svg";